import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter, Link} from 'react-router-dom';
import {COLORS} from '../constants';


class Crumbs extends Component {

  static defaultProps = {
    crumbs: [],
  }

  renderCrumbs() {
    const {crumbs} = this.props;

    return crumbs.map((c, index) => (
      <Crumb 
        key={index} 
        crumb={c} 
        showArrow={crumbs.length > index + 1}
      />
    ))
  }

  render() {
    return(
      <div style={s.container}>
        {this.renderCrumbs()}
      </div>
    )
  }
}


const Crumb = ({crumb, showArrow}) => {
  const s = {
    container: {
      display: 'flex',
      marginRight: '10px',
    },
    label: {
      marginRight: '10px',
      fontSize: '80%',
      color: COLORS.gray200,
      textTransform: 'uppercase',
    },
    labelWithLink: {
      marginRight: '10px',
      fontSize: '80%',
      color: COLORS.gray200,
      textTransform: 'uppercase',
      fontWeight: 'bold',
    },
    arrow: {
      fontSize: '80%',
      color: COLORS.gray200,
    },
  }

  const c = crumb;

  if (c.link) {
    return (
      <div style={s.container}>
        <Link to={c.link} className="nostyle">
          <div style={s.labelWithLink}>
            {c.label}
          </div>
        </Link>

        {showArrow &&
          <div style={s.arrow}>
            >
          </div>
        }
      </div>
    )
  }

  else {
    return (
      <div style={s.container}>
        <div style={s.label}>
          {c.label}
        </div>

        {showArrow &&
          <div style={s.arrow}>
            >
          </div>
        }
      </div>
    )
  }
}


const s = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    userSelect: 'none',
  },
}

const mapStateToProps = (state, ownProps) => {
  return {

  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}


const Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(Crumbs)

export default withRouter(Connected);



// WEBPACK FOOTER //
// ./src/main/Crumbs.js